<template>
  <DefaultSection class="section is-medium howto sky-blue">
    <div class="container">
      <h2
        class="title is-size-medium has-text-centered has-text-weight-bold mb-6"
      >
        {{ title }}
      </h2>
      <div
        class="is-flex is-justify-content-space-between is-align-items-center icon-list"
      >
        <div v-for="(icon, key) in icons" :key="key" class="item">
          <div
            class="white-border-icon is-size-balanced is-flex is-flex-direction-column is-justify-content-center is-align-items-center"
          >
            <MediaSvgIcon v-if="icon" v-bind="icon" class="svg-image" />
            <div class="mt-4 has-text-weight-bold image-caption">
              <span>{{ icon?.caption }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="text"
        class="mb-5 has-text-weight-semibold has-text-centered content"
        v-html="text"
      />
      <div class="has-text-centered mt-6">
        <VuepalLink
          v-if="link && link.url"
          :to="link.url.path"
          class="button is-lessmess-app has-text-primary large has-text-weight-bold is-size-6"
        >
          {{ link.title }}
        </VuepalLink>
      </div>
    </div>
  </DefaultSection>
</template>

<script setup lang="ts">
import type { ParagraphSmartCityFragment } from '#graphql-operations'

defineProps<ParagraphSmartCityFragment>()

defineBlokkli({
  bundle: 'smart_city',
})
</script>

<style scoped lang="scss">
.sky-blue {
  background-color: $sky-blue-18;
}

.icon-list {
  margin-top: toRem(30);
  margin-bottom: toRem(30);

  flex-direction: column;

  @include tablet {
    flex-direction: row;
  }

  @include tablet {
    margin-right: 145px;
    margin-left: 145px;

    margin-top: toRem(60);
    margin-bottom: toRem(60);
  }

  .item {
    border: 3px solid $white;
    border-radius: 50%;

    width: 150px;
    height: 150px;
    margin-bottom: 20px;

    @include tablet {
      width: 170px;
      height: 170px;
      margin-bottom: 0;
    }

    @include desktop {
      width: 200px;
      height: 200px;
      margin-bottom: 0;
    }

    @include widescreen {
      width: 230px;
      height: 230px;
    }

    .white-border-icon {
      //height: 220px;
      color: $friendly-blue;
      height: 100%;

      .svg-image {
        height: 30px;
        width: 30px;

        @include tablet {
          height: 50px;
          width: 50px;
        }

        fill: $friendly-blue;
        stroke: $friendly-blue;
        g {
          stroke: $friendly-blue;
        }
      }

      .image-caption {
        text-align: center;
        line-height: 1.7rem;
        max-width: 75%;
      }
    }
  }
}
</style>
